<p-dialog
  data-testid="por-stock-selection-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '1200px', maxWidth: '95vw' }"
  [header]="getDialogHeader()"
  (onHide)="onCancel()"
>
  <!-- Stock Items Table -->
  <div class="mb-4">
    <app-data-table
      data-testid="por-stock-selection-dialog-table"
      [dataSource]="stockItems()"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [rows]="20"
      [selection]="selectedItems()"
      (selectionChange)="onSelectionChange($event)"
      [hasCheckColumn]="true"
      [hasHeaderCheckbox]="true"
      [hasSerialColumn]="false"
      [isRowSelectedFn]="getSelectionState.bind(this)"
      [isRowDisabledFn]="isRowDisabled.bind(this)"
      (pageChange)="onLazyLoad($event)"
      [scrollHeight]="'500px'"
      class="w-full"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <!-- Cancel button -->
      <app-button
        [testId]="'por-stock-selection-dialog-cancel-btn'"
        label="common.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading()"
      ></app-button>

      <!-- Confirm button -->
      <app-button
        [testId]="'por-stock-selection-dialog-confirm-btn'"
        label="common.actions.confirm"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="loading() || selectedItems().length === 0"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="por-stock-selection-dialog-toast"></p-toast>
